import {Observable, Subject} from 'rxjs';

export class AppDialogRef<T = unknown> {
	private readonly close$ = new Subject<T | undefined>();
	readonly onClose: Observable<T | undefined> = this.close$.asObservable();
	componentRef: T | null = null;
	private closed = false;
	private primeRef?: import('primeng/dynamicdialog').DynamicDialogRef;
	private closeHandler?: (result?: T) => void;

	attachPrimeRef(ref: import('primeng/dynamicdialog').DynamicDialogRef | null | undefined): void {
		if (ref) {
			this.primeRef = ref;
		}
	}

	attachCloseHandler(handler: (result?: T) => void): void {
		this.closeHandler = handler;
	}

	close(result?: T): void {
		if (this.closed) {
			return;
		}
		if (this.closeHandler) {
			this.closeHandler(result);
			return;
		}
		if (this.primeRef) {
			this.closed = true;
			this.primeRef.close(result);
			setTimeout(() => {
				if (this.primeRef) {
					this.primeRef.destroy();
				}
			}, 400);
			this.close$.next(result);
			this.close$.complete();
			return;
		}
		this.finalizeClose(result);
	}

	notifyClosed(result?: T): void {
		this.finalizeClose(result);
	}

	private finalizeClose(result?: T): void {
		if (this.closed) {
			return;
		}
		this.closed = true;
		this.close$.next(result);
		this.close$.complete();
	}
}
